import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertModalComponent, modalTypes } from '@components/modals/alert-modal/alert-modal.component';
import { LabelTextPipe } from '@pipes/label-text.pipe';
import { SpinnerService } from '@services/spinner.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class FilesUploadingInterceptor implements HttpInterceptor {
  constructor(
    private bsModalService: BsModalService,
    private spinnerService: SpinnerService,
    private labelTextPipe: LabelTextPipe
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError(async error => {
        try {
          if (error instanceof HttpErrorResponse && error.status === 400) {
            const responseBody = error.error instanceof Blob ? await error.error.text() : error.error;
            const errorDetails = typeof responseBody === 'string' ? JSON.parse(responseBody) : responseBody;
            const invalidFiles = errorDetails?.invalidFiles;

            if (Array.isArray(invalidFiles) && invalidFiles.length > 0) {
              const requestBody = typeof request.body === 'string' ? JSON.parse(request.body) : request.body;
              if (Array.isArray(requestBody) && requestBody.length > 0) {
                const modal = this.bsModalService.show(AlertModalComponent, {
                  initialState: {
                    type: modalTypes.error,
                    title: `${this.labelTextPipe.transform('Common.DocsWithErrorsModalTitle')} :`,
                    body: this.prepareErrorModalBody(requestBody, errorDetails)
                  },
                  class: 'modal-lg'
                });

                modal.content.onClose.subscribe(() => {
                  this.spinnerService.isLoading.next(false);
                });
              }
            }
          }
        } finally {
          throw error;
        }
      })
    );
  }

  private prepareErrorModalBody(arrOfFiles: any[], errorDetails: any): string {
    const subTitle = this.labelTextPipe.transform('Common.DocsWithErrorsModalSubTitle');
    let body = `<span class='recap-li-font-style'> ${subTitle} <span> <span class="recap-promo compact"> <ul class="list-arrows">`;

    errorDetails.invalidFiles.forEach((invalidFileError: any) => {
      body += `<li> ${arrOfFiles[invalidFileError.index].file?.fileName} </li>`;
    });

    body += '</ul> </span>';

    return body;
  }
}
